// API Configuration
// Automatically uses the correct API URL based on environment
// Development: http://localhost:5000
// Production: https://webapi.machinerya3.ro

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getApiUrl = () => API_URL;

export const getApiEndpoint = (path) => {
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
};

export const getUploadUrl = (filename) => {
  // Handle both full paths and filenames
  if (filename.startsWith('/uploads/')) {
    return `${API_URL}${filename}`;
  }
  if (filename.startsWith('/')) {
    return `${API_URL}${filename}`;
  }
  return `${API_URL}/uploads/${filename}`;
};

const apiConfig = {
  apiUrl: API_URL,
  getApiUrl,
  getApiEndpoint,
  getUploadUrl
};

export default apiConfig;
